import { Component, Inject, OnInit } from '@angular/core';
import { DialogData } from '../../interfaces/dialog-data';
import { MessageSeverity } from '../../enums/message-severity';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css']
})

export class DialogComponent implements OnInit {

    public iconClassName: string = "";
    public matIconName: string = "";

    public constructor(public dialogReference: MatDialogRef<DialogComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: DialogData) {

        switch (dialogData.Severity) {

            case MessageSeverity.Success:

                this.iconClassName = "dialog-icon-color-success";
                this.matIconName = "thumb_up";

                break;

            case MessageSeverity.Info:

                this.iconClassName = "dialog-icon-color-info";
                this.matIconName = "info";

                break;

            case MessageSeverity.Warning:

                this.iconClassName = "dialog-icon-color-warning";
                this.matIconName = "warning";

                break;

            case MessageSeverity.Error:

                this.iconClassName = "dialog-icon-color-error";
                this.matIconName = "dangerous";

                break;
        }
    }

    public ngOnInit(): void { }

    public confirm = (): void => {

        this.dialogReference.close(this.dialogData.AcceptButtonText);
    }

    public cancel = (): void => {

        this.dialogReference.close(this.dialogData.CancelButtonText);
    }
}
